import React,{useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Skills.css';
import JS from '../../Assets/js.png';
import VB from '../../Assets/vb.png';
import ReactJS from '../../Assets/reactjs.png';
import CSS from '../../Assets/css-3.png';
import Mysql from '../../Assets/mysql.png';
import Java from '../../Assets/java.png';
import HTML5 from '../../Assets/html-5.png';
import SoftwareApplication from '../../Assets/spreadsheet.png';  
import SoftwareTroubleshoot from '../../Assets/system.png';  
import HardwareTroubleshoot from '../../Assets/troubleshooting.png';  
import Networking from '../../Assets/computer.png';  






const Skills = () => {

   

  useEffect(() => {
    AOS.init();
  }, [])






  return (
    <section id="skills" >
      <div className="allSkills">
       <div className="textContainer">
        <div className="skillsDesc">
            <h1
                data-aos="fade-up"
                data-aos-offset="-400"
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease"
                data-aos-mirror="true"
                data-aos-once="false"
                data-aos-anchor-placement="top-center">What I do</h1>
            <p
                data-aos="fade-up"
                data-aos-offset="-400"
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease"
                data-aos-mirror="true"
                data-aos-once="false"
                data-aos-anchor-placement="top-center">I'm a recent graduate and aspiring web developer with a strong desire to broaden my technological knowledge and a keen interest in crafting both visually appealing designs and seamless website functionality</p>
        </div>
       </div>
        <div className="skillsContainer">
            <div className="codingSkills">
          <h2 
           data-aos="fade"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">Programming/Library Skills</h2>  
          <div className="codingList">
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >

             <img src={ReactJS} alt="ReactJS" className="skillsIcons" />
              <span>ReactJS</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `43%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">43%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={HTML5} alt="HTML5" className="skillsIcons" />
              <span>HTML5</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `68%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">68%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={CSS} alt="CSS" className="skillsIcons" />
              <span>CSS3</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `62%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">62%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={JS} alt="JS" className="skillsIcons" />
              <span>Javascript</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `38%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">38%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={Java} alt="Java" className="skillsIcons" />
              <span>Java</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `32%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">32%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={VB} alt="VB.net" className="skillsIcons" />
              <span>VB.net</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `58%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">58%</span>
            </div>
            </div>
            <div className="progSkills">
             <div className="progLanguage"
           data-aos="fade-up-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
             <img src={Mysql} alt="Mysql" className="skillsIcons" />
              <span>Mysql</span>
             </div>
             <div className="progressbar-container">
               <div className="progressbar-complete" style={{width: `63%`}}
           data-aos="slide-right"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="2000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
                 <div className="progressbar-liquid"></div>
               </div>
             <span className="progress">63%</span>
            </div>
            </div>

          
          </div>
            </div>
            <div className="otherSkills">
             <h2 
           data-aos="fade"
           data-aos-offset="-400"
           data-aos-delay="50"
           data-aos-duration="1000"
           data-aos-easing="ease"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center">Other Skills</h2> 
      <div className="skillBars2">
        <div className='skillBar'
           data-aos="fade-up-left"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
          <img src={SoftwareApplication} alt="SoftwareApplication" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Software Applications</h2>
            <p>My skills include Microsoft 365 competency as well as good`` understanding of Adobe Photoshop and Adobe Illustrator, allowing me to efficiently use and navigate these software products for a variety of jobs and projects.</p>
          </div>
        </div>
        <div className='skillBar'
           data-aos="fade-up-left"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
          <img src={SoftwareTroubleshoot} alt="SoftwareTroubleshoot" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Software Troubleshoot</h2>
            <p>I possess strong troubleshooting skills,  specializing in diagnosing and resolving software-related difficulties, particularly on Windows operating systems.</p>
          </div>
        </div>
        <div className='skillBar'
           data-aos="fade-up-left"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
          <img src={HardwareTroubleshoot} alt="HardwareTroubleshoot" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Hardware Troubleshoot</h2>
            <p>I possess expertise in computer hardware troubleshooting, allowing me to effectively detect and address hardware-related issues, assuring optimal system performance.</p>
          </div>
        </div>
        <div className='skillBar'
           data-aos="fade-up-left"
           data-aos-offset="-400"
           data-aos-delay="200"
           data-aos-duration="1000"
           data-aos-easing="ease-in-out-quart"
           data-aos-mirror="true"
           data-aos-once="false"
           data-aos-anchor-placement="top-center"
          >
          <img src={Networking} alt="Networking" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Networking</h2>
            <p>
In terms of networking, I have a basic understanding of network components, IP addressing, subnetting, and basic network configuration, which enables me to perform simple networking tasks and troubleshoot basic network issues.</p>
          </div>
        </div>
      </div>
            </div>
        
        </div>
        </div>
    </section>
  )
}

export default Skills
